import axios from 'axios';

const API_HOST = process.env.REACT_APP_API_BASE_PATH;

export const getGochiMenusData = params =>
  axios.get(`${API_HOST}/v2/menus`, { params, withCredentials: true });

export const getGroupMenusData = params =>
  axios.get(`${API_HOST}/budget/group/menu`, { params, withCredentials: true });

export const getChargeAmountData = params =>
  axios.get(`${API_HOST}/budget/menu/chargeAmount`, {
    params,
    withCredentials: true
  });

export const postBudgetGochiData = params =>
  axios.post(`${API_HOST}/budget/gochi`, params, {
    withCredentials: true
  });

export const getGochiMenuDetailData = menuId =>
  axios.get(`${API_HOST}/menus/${menuId}`, { withCredentials: true });

export const addGochiMenuData = params =>
  axios.post(`${API_HOST}/menus`, params, { withCredentials: true });

export const editGochiMenuData = (menuId, params) =>
  axios.put(`${API_HOST}/menus/${menuId}`, params, { withCredentials: true });

export const editOrderGochiMenusData = params =>
  axios.put(`${API_HOST}/menus/viewOrder`, params, { withCredentials: true });

export const deleteGochiMenuData = menuId =>
  axios.delete(`${API_HOST}/menus/${menuId}`, { withCredentials: true });

export const showHideGochiMenuData = (menuId, params) =>
  axios.put(`${API_HOST}/menus/${menuId}/showHide`, params, {
    withCredentials: true
  });

export const ignoreGochiMenuData = (menuId, isShow) =>
  axios.put(`${API_HOST}/menus/${menuId}/ignore`, isShow, {
    withCredentials: true
  });

export const changeShashokuOptionData = (menuId, shashokuOn, gochimeshiOn) =>
  axios.put(
    `${API_HOST}/menus/${menuId}/shashoku-option`,
    { menuId, shashokuOn, gochimeshiOn },
    {
      withCredentials: true
    }
  );

export const addGochiMenuImageData = (menuId, params) =>
  axios.post(`${API_HOST}/menus/${menuId}/image`, params, {
    withCredentials: true
  });

export const downloadMenuData = params =>
  axios.get(`${API_HOST}/menus/download`, { params, withCredentials: true });

export const createSecretMenuData = () =>
  axios.get(`${API_HOST}/menus/sakimeshi/auto`, { withCredentials: true });

export const getMenuOneToNData = params =>
  axios.get(`${API_HOST}/menus/oneToNTickets`, {
    params,
    withCredentials: true
  });

export const addMenuEventData = params =>
  axios.put(`${API_HOST}/menus/shopFee`, params, {
    withCredentials: true
  });

export const deleteMenuEventData = menuId =>
  axios.delete(`${API_HOST}/menus/shopFee/${menuId}`, {
    withCredentials: true
  });

export const getMenuSettingData = shopId =>
  axios.get(`${API_HOST}/shops/${shopId}/menuSetting`, {
    withCredentials: true
  });

// export const addMenuSettingData = params =>
//   axios.post(`${API_HOST}/v2/menu-setting`, params, {
//     withCredentials: true
//   });
export const editMenuSettingData = ({ params, shopId }) =>
  axios.put(`${API_HOST}/shops/${shopId}/menuSetting`, params, {
    withCredentials: true
  });

export const addGochiKidMenuData = (menuId, params) =>
  axios.put(`${API_HOST}/manage/gochi-kid/menus/${menuId}`, params, {
    withCredentials: true
  });

export const removeGochiKidMenuData = (menuId, params) =>
  axios.put(`${API_HOST}/manage/gochi-kid/menus/${menuId}`, params, {
    withCredentials: true
  });

export const getGochiKidMenusData = params =>
  axios.get(`${API_HOST}/manage/gochi-kid/menus`, {
    params,
    withCredentials: true
  });

export const downloadGochiKidMenusData = params =>
  axios.get(`${API_HOST}/manage/gochi-kid/menus/download`, {
    params,
    withCredentials: true
  });

export const getMenuImageSampleData = () =>
  axios.get(`${API_HOST}/menus/menu-image-sample`, {
    withCredentials: true
  });

export const getSettingMenuFreeData = menuId =>
  axios.get(`${API_HOST}/manage/gochi-kid/free/menus/${menuId}/detail`, {
    withCredentials: true
  });

export const settingMenuFreeData = (menuId, params) =>
  axios.put(`${API_HOST}/manage/gochi-kid/free/menus/${menuId}`, params, {
    withCredentials: true
  });

export const deleteSettingMenuFreeData = menuId =>
  axios.delete(`${API_HOST}/manage/gochi-kid/free/menus/${menuId}`, {
    withCredentials: true
  });

export const getListSettingMenuFreeData = params =>
  axios.get(`${API_HOST}/manage/gochi-kid/free/menus?`, {
    params,
    withCredentials: true
  });
